// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-iXqGw","btnDetail":"index-btnDetail-2lcHc"};